// ================ New Upsell design JS start ================ //
let productPageGPO = "";
if ($("body.template-product .product-section").length !== 0) {
  productPageGPO = ".page-content--product .gpo-swatches.image-swatches";
}

if (productPageGPO !== "") {
  let findGPO = setInterval(function () {
    changeStructure(productPageGPO, findGPO);
  }, 100);
  setTimeout(function () {
    clearInterval(findGPO);
  }, 50000);
}

function changeStructure(GPO_Data, intervalId) {
  if ($(GPO_Data).length === 0) {
    return;
  }
  clearInterval(intervalId);
  let product_id = $('input[name="product-id"]').val();
 if(product_id == 14837341225305 || product_id == 14879921537410 || product_id == 14874524516738 || product_id == 7837094248566 ){
     var add_upsell_option = $('.gpo-app .wheel_mount .gpo-ov-wrapper');
    if (add_upsell_option.length) {
        add_upsell_option.prepend('<div class="gpo-swatches gpo-ov-item custom_option"><label><img src="https://cdn.shopify.com/s/files/1/0603/6268/6658/files/TR_ONE_BASE.jpg?v=1735905059" /></label><div class="upsell_all_detail"><div class="included_tag">INCLUDED</div><div class="upsell_detail"><div class="upsell_name">TR ONE BASE FITS FANATEC DD</div></div></div></div>');
    } else {
        console.log('Target element not found');
    }
  }

  if(product_id == 7646170316918 || 7646170906742){
     var add_upsell_option_trx = $('.gpo-app .wheel_mount_image .gpo-ov-wrapper');
    if (add_upsell_option_trx.length) {
        add_upsell_option_trx.prepend('<div class="gpo-swatches gpo-ov-item custom_option"><label><img src="https://cdn.shopify.com/s/files/1/0606/8649/9958/files/TR_ONE_BASE_412087f1-f2df-46ff-bd55-3ead2442bbfc.jpg?v=1753437882" /></label><div class="upsell_all_detail"><div class="included_tag">INCLUDED</div><div class="upsell_detail"><div class="upsell_name">FANATEC DD SIDE MOUNT</div></div></div></div>');
    } else {
        console.log('Target element not found');
    }
  }

  if(product_id == 7646172774518 || 7690471571574){
     var add_upsell_option_trx = $('.gpo-app .custom-trx .gpo-ov-wrapper');
    if (add_upsell_option_trx.length) {
        add_upsell_option_trx.prepend('<div class="gpo-swatches gpo-ov-item custom_option"><label><img src="https://cdn.shopify.com/s/files/1/0606/8649/9958/files/PHOTO-2025-01-29-00-45-12_1.jpg?v=1738555771" /></label><div class="upsell_all_detail"><div class="included_tag">INCLUDED</div><div class="upsell_detail"><div class="upsell_name">FANATEC DD SIDE MOUNT</div></div></div></div>');
    } else {
        console.log('Target element not found');
    }
  }

  if(product_id == 7774755192950){
     var add_upsell_option_Simulator = $('.gpo-app .gold-custom-trx .gpo-ov-wrapper');
    if (add_upsell_option_Simulator.length) {
        add_upsell_option_Simulator.prepend('<div class="gpo-swatches gpo-ov-item custom_option"><label><img src="https://cdn.shopify.com/s/files/1/0606/8649/9958/files/Gold_Seat.jpg?v=1751959668" /></label><div class="upsell_all_detail"><div class="included_tag">INCLUDED</div><div class="upsell_detail"><div class="upsell_name">Gold Seat</div></div></div></div>');
    } else {
        console.log('Target element not found');
    }
  }

  //  if(product_id == 7646182080630){
  //    var add_upsell_option_trx = $('.gpo-app .custom-wheelmount-trx .gpo-ov-wrapper');
  //   if (add_upsell_option_trx.length) {
  //       add_upsell_option_trx.prepend('<div class="gpo-swatches gpo-ov-item custom_option"><label><img src="https://cdn.shopify.com/s/files/1/0606/8649/9958/files/TR80-NWMA-WM4_1.png?v=1752038545" /></label><div class="upsell_all_detail"><div class="included_tag">INCLUDED</div><div class="upsell_detail"><div class="upsell_name">Universal Wheel Deck</div></div></div></div>');
  //   } else {
  //       console.log('Target element not found');
  //   }
  // }

  if(product_id == 7646180769910 || product_id == 7646182080630 || product_id == 7775036244086){
     var add_upsell_option_trx = $('.gpo-app .custom-wheelmount-trx .gpo-ov-wrapper');
    if (add_upsell_option_trx.length) {
        add_upsell_option_trx.prepend('<div class="gpo-swatches gpo-ov-item custom_option"><label><img src="https://cdn.shopify.com/s/files/1/0606/8649/9958/files/TR80-NWMA-WM4_1.png?v=1752038545" /></label><div class="upsell_all_detail"><div class="included_tag">INCLUDED</div><div class="upsell_detail"><div class="upsell_name">Universal Wheel Deck</div></div></div></div>');
    } else {
        console.log('Target element not found');
    }
  }

  if(product_id == 7836099969142){
     var add_upsell_option_trx = $('.gpo-app .custom-wheelmount-trx .gpo-ov-wrapper');
    if (add_upsell_option_trx.length) {
        add_upsell_option_trx.prepend('<div class="gpo-swatches gpo-ov-item custom_option"><label><img src="https://cdn.shopify.com/s/files/1/0606/8649/9958/files/TR80-WMPLATE.png?v=1752122871" /></label><div class="upsell_all_detail"><div class="included_tag">INCLUDED</div><div class="upsell_detail"><div class="upsell_name">Universal Wheel Deck</div></div></div></div>');
    } else {
        console.log('Target element not found');
    }
  }

  let upsell = $(".gpo-swatches.image-swatches.gpo-ov-item");
  $(".gpo-app .gpo-swatches input").show();
  $(".gpo-app .gpo-swatches .gpo-ov-extend").remove();
  for (i = 0; i < upsell.length; i++) {
    let upsell_name = $(upsell[i]).find(".gpo-tooltip.zoom-image .gpo-tooltip__title span:first-child").text();
    let upsell_price = $(upsell[i]).find(".gpo-tooltip.zoom-image .gpo-tooltip__title span.addOn").text().replace(/[()+]/g, "");
    if (upsell_price != "") {
      upsell_price = upsell_price.trim();
    }
    let upsell_image_span = $(upsell[i]).find(".gpo-swatch__inner .swatch-image");
    var backgroundImage = $(upsell_image_span).attr("src");

    var image_new = $(upsell[i]).find(".gpo-swatch__inner");
    if (backgroundImage) {
      let backgroundImage_src = backgroundImage.split("?")[0]; // Get base URL before any query params
      image_new.append(`<div class="upsell_image_div"><img src="${backgroundImage_src}"></div>`);
    } else {
      image_new.append(`<div class="upsell_image_div"><img src="fallback-image.jpg" alt="No image available"></div>`);
    }
    $(upsell[i]).append(`<div class="upsell_detail"><div class="upsell_price">${upsell_price}</div><div class="upsell_name">${upsell_name}</div></div>`);
    $(upsell_image_span).css("background", "none");
    $(upsell[i]).append('<div class="upsell_all_detail"></div>');
    let find_input = $(upsell[i]).find("input");
    let find_selected_input = $(upsell[i]).find("input:checked");
    let upsell_div = $(upsell[i]).find(".upsell_all_detail");
    let upsell_detail = $(upsell[i]).find(".upsell_detail");
    upsell_div.append(find_input);
    upsell_div.append(upsell_detail);
    $(find_selected_input)
      .closest(".upsell_all_detail")
      .addClass("has-checked");
    const $input = $(upsell[i]).find("input");
    const productHandle = $input.attr("gpo-data-product-handle");
    const productVarId = $input.attr("gpo-data-variant-id");
    $(upsell[i]).append(
      `<div class="stock_main"><span class="upsell_stock" data-handle="${productHandle}"></span></div>`
    );
    $(upsell[i]).append(
      `<div class="test_box" id="test_box_${productHandle}"></div>`
    );
    if (productHandle !== "" && productHandle !== undefined) {
      getProductAvailability(productHandle, productVarId);
      var view_product_url =
        productVarId !== ""
          ? `${location.origin}/products/${productHandle}?variant=${productVarId}`
          : `${location.origin}/products/${productHandle}`;
      $(upsell[i])
        .find("label")
        .append(
          `<a href="${view_product_url}" name="product_info_link" class="product_info_link" target="_blank">View Info</a>`
        );

      const link = upsell[i].querySelector(".product_info_link");
      const testBox = upsell[i].querySelector(".test_box");
      link.addEventListener("click", function (event) {
        event.stopPropagation();
      });
    }
  }

  var options_groups = $(".gpo-app .none_selection .gpo-ov-wrapper");
  for (let i = 0; i < options_groups.length; i++) {
    var options = $(options_groups[i]).find(".gpo-swatches.image-swatches.gpo-ov-item");
    for (let j = 0; j < options.length; j++) {
      $(options[j]).attr("data-custom-index", j);
    }
  }
  $(document).on("click", ".gpo-app .none_selection .gpo-ov-wrapper .test_box", function () {
    var current_parent = $(this).closest(".gpo-form__group");
    var data_index = $(this).closest(".gpo-swatches").data("custom-index");
    if (data_index > 0) {
      var data_index_0 = $(current_parent).find(".gpo-swatches[data-custom-index=0]");
      var check_class = $(data_index_0).find(".upsell_all_detail.has-checked");
      if (check_class.length > 0) {
        $(data_index_0).find("label").click();
        $(current_parent).find(".gpo-swatches[data-custom-index=0]").find(".upsell_all_detail.has-checked").removeClass("has-checked");
      }
    }
    if (data_index == 0) {
      var data_index_all = $(current_parent).find(".gpo-swatches[data-custom-index!=0] .upsell_all_detail.has-checked");
      $(data_index_all).siblings("label").click();
    }
  });

  // Upsell Slider initialization
  $(".page-content--product .gpo-element .gpo-ov-wrapper").slick({
    arrows: true,
    infinite: false,
    speed: 300,
    slidesToShow: 4.5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3.5,
        },
      },
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 3.5,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2.5,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2.5,
          slidesToScroll: 2,
        },
      },
    ],
  });
}

function getProductAvailability(p_Handle, p_variant) {
  var product_url = p_variant !== "" ? `${location.origin}/products/${p_Handle}?variant=${p_variant}&view=product_availability_data_upsell` : `${location.origin}/products/${p_Handle}?view=product_availability_data_upsell`;
  
  var only_url = p_variant !== "" ? `${location.origin}/products/${p_Handle}?variant=${p_variant}` : `${location.origin}/products/${p_Handle}`;
  $.ajax({
    url: product_url,
    type: "GET",
    success: function (data) {

      $("body").append(`<div class="apiData hide"></div>`);
      $(data).appendTo(".apiData");
      var Product_Availability = "",
        Product_restock = "",
        Product_eta = "",
        $productElement = $(`[gpo-data-product-handle=${p_Handle}]`),
        Product_link = $(".apiData .Product_link").text();
        Product_restock = $(".apiData .product-info__inventory span").data("stock");
      if (Product_restock == "In-Stock") {
        $(`span[data-handle="${p_Handle}"]`).addClass("instock").text(Product_restock);
      } else if (Product_restock == "Pre-Order") {
        $(`span[data-handle="${p_Handle}"]`).addClass("preorder").text(Product_restock);
      } else {
        $(`span[data-handle="${p_Handle}"]`).addClass("outofstock").text(Product_restock);
      }

      if (Product_restock == "Sold Out") {
        $("#test_box_" + p_Handle).addClass("sold_out");
        $("#test_box_" + p_Handle).closest(".gpo-swatches.image-swatches").addClass("sold_out_main_div");
      }

      $("body .apiData").remove();
    },
    error: function (error) {
      // Log an error message if the AJAX request fails
      console.error("Error fetching product information:", error);
      var url = $(`[href="${only_url}"]`);
      $(url).hide();
      
      $(`#test_box_${p_Handle}`).closest(".gpo-swatches").css("pointer-events", "none");
      document.getElementById(`test_box_${p_Handle}`).disabled = true;
    },
  });
}

$(document).on("click", ".gpo-swatches .test_box", function () {
  $(this).closest(".gpo-swatches").find("label").click();
});

$(document).on("click", ".gpo-swatches label", function() {
  let find_selected_input = $(this).closest('.gpo-swatches').find('input');
  let checkHasClass = $(find_selected_input).closest('.upsell_all_detail').hasClass('has-checked');
  let input_type = find_selected_input.attr('type');
  if (input_type == "radio") {
    $(this).closest('.gpo-ov-wrapper').find(".upsell_all_detail").removeClass("has-checked");
  }
  if (checkHasClass) {
    $(find_selected_input).closest('.upsell_all_detail').removeClass('has-checked');
  } else {
    $(find_selected_input).closest('.upsell_all_detail').addClass('has-checked');
  }
});
// ================ New Upsell design JS end ================ //

window.theme = window.theme || {};
window.custom = window.custom || {};

function checkLocationDom() {
  var inventoryInfo = document.getElementById("inventoryLocationInformation");
  if (inventoryInfo !== null) {
    clearInterval(checkLocationDomInterval);
    var checkLocationList = setInterval(function(){
      var locationList = inventoryInfo.querySelectorAll("ul li");
      var locationUl = inventoryInfo.querySelector("ul");
      if (locationList.length > 0) {
        locationUl.classList.add('clearInterval');
        var inStock = false;
        locationList.forEach(function(data){
          var infoText = data.querySelector(".stockCount").innerText.trim();
          if(infoText === 'In stock'){
            inStock = true;
          } else if (infoText === 'Out of stock') {
            data.style.display = "none";
          }
        });
        clearInterval(checkLocationList);
      }else if ($(document).find('#inventoryLocationInformation').find('.tomitUnavailable').length){
        
        $(document).find('#metafield-option').show();
        $(document).find('#metafield-option input').removeAttr("disabled");
        
        var mainSelect = $(document).find('.main-select-variants');
        var selectedOption = mainSelect.find('option:selected').data('preorder');
        if(selectedOption){
          // $(document).find('.custom-add__btn').find('span').text(theme.strings.preOrder);
          mainSelect.addClass('preorder-update');
        }
      }
    }, 10);
    setTimeout(function(){
      clearInterval(checkLocationList);
    }, 2000);
  }
}

const checkLocationDomInterval = setInterval(checkLocationDom, 10);

setTimeout(function(){
  clearInterval(checkLocationDomInterval);
}, 50000);

(function ($) {
  var $ = (jQuery = $);

  /*==========================================================================
    Theme Functionality
  ============================================================================*/
  custom.init = function () {
    // custom.bindCustomEvents();
  };

  custom.Collection = (function () {
    const selectors = {
      tabs: "featured-collections__nav",
      tabItem: "featured-collections__nav-item",
      grid: "grid",
      animate: "aos-animate",
      activeTab: "is-active",
    };
    function Collection($el) {
      this.$tabs = $el.querySelector(`.${selectors.tabs}`);
      this.init();
    }

    Collection.prototype = $.extend({}, Collection.prototype, {
  
      toggleActiveClass: function($el) {
        $el.classList.toggle(selectors.activeTab);
      },
      getTabTarget: function(id) {
        return document.getElementById(id)
      },
      unsetActive: function() {
        const activeTab = this.$tabs.querySelector(`.${selectors.activeTab}`);
        const activeTabContent = this.getTabTarget(activeTab.dataset.tab);
        this.toggleActiveClass(activeTab);
        this.toggleActiveClass(activeTabContent);
        const animate = activeTabContent.querySelector('.grid');
        if ( animate ) {
          animate.classList.remove("aos-animate")
        }
    
      },
      setActiveTab: function(target) {
        const activeTabContent = this.getTabTarget(target.dataset.tab);
        this.toggleActiveClass(target);
        this.toggleActiveClass(activeTabContent);
        const animate = activeTabContent.querySelector('.grid');
        if ( animate ) {
          animate.classList.add("aos-animate")
        }
        
      },
      toggleActiveTab: function(event) {
        event.preventDefault()
        let target = event.target;
        if (target.tagName === "UL") {
          return false
        }
        if (target.tagName === "LI") {
            target = target.querySelector('a'); 
        }
        if (!target.classList.contains(selectors.activeTab)) {
          this.unsetActive()
          this.setActiveTab(target)
        }
      },
      initEventListeners: function() {
        if (this.$tabs) {
          this.$tabs.addEventListener("click", this.toggleActiveTab.bind(this));
        }

      },
      setTabs: function () {
        this.initEventListeners();
      },

      init: function () {
        this.setTabs();
      },
    });

    return Collection;
  })();

  /*==========================================================================
    Initialize
  ============================================================================*/

  $(document).ready(function () {
    custom.init();

    window.sections = window.sections || new theme.Sections();
    // homepage
    if ($("body").hasClass("template-index")) {
      sections.register("collection-template", custom.Collection);
    }

    // NZ and UK custom.js doesn't have the code block below
    if (['uk', 'nz', 'au', 'eu', 'us'].includes(window.region)) {
      $('.upsell_gallery').each(function () {
        $(this).find('.upsell_main_images').slick({
          infinite: true,
          slidesToShow: 1,
          responsive: [
            {
              breakpoint: 991,
              settings: {
                dots: true
              }
            }
          ]
        });

        $(this).find('.upsell_gallery_thumbnails').slick({
          infinite: false,
          slidesToShow: 2,
          focusOnSelect: true,
          asNavFor: `#${this.id} .upsell_main_images`
        });
      });
  
      $('.upsell_main_images').on('beforeChange', function(e, slick, last, next) {
        $(this).parents('.upsell_gallery').find(`.upsell_gallery_thumbnail[data-slick-index=${ next }]`).click();
      });
    }
  });
})(theme.jQuery);


$(document).on("click", ".manual_gallery_tab .btn.collapsible--btn", function () {
  let tabTitle = $(this).data("tab");
  let emptyMsg = $(".manual_gallery_tab .product__additional-content .empty_msg");
  let hasFilterData = false;
  $(".manual_gallery_tab .btn.collapsible--btn").removeClass("is-open").attr("aria-expanded", "false");
  $(this).addClass("is-open").attr("aria-expanded", "true");
  $(".manual_gallery_tab .manual_gallery_tab_content .grid__item").show().each(function (index, grid) {
    let hasDoc = $(grid).data("hasdoc");
    let hasVideo = $(grid).data("hasvideo");
    if ((tabTitle.includes('doc') && !hasDoc) || (tabTitle.includes('video') && !hasVideo)) {
      $(grid).hide();
    } else {
      hasFilterData = true;
    }
  });
  hasFilterData ? emptyMsg.hide() : emptyMsg.show();
});

//recently view products 
document.addEventListener('DOMContentLoaded', function() {
  if (window.location.pathname.includes("/products/")) {
    // Get the current product handle
    var product_url = window.location.pathname;
    var parts = product_url.split("/");
    var product_handle = parts[parts.length - 1];
  
    // Get existing viewed products from localStorage
    var recentlyViewedProducts = JSON.parse(localStorage.getItem('recentlyViewedProducts')) || [];

    // Remove the current product if it's already in the array
    recentlyViewedProducts = recentlyViewedProducts.filter(handle => handle !== product_handle);

    // Add the current product to the front of the array
    recentlyViewedProducts.unshift(product_handle);

    // Limit the number of stored products (e.g., 5)
    recentlyViewedProducts = recentlyViewedProducts.slice(0, 5);

    // Save back to localStorage
    localStorage.setItem('recentlyViewedProducts', JSON.stringify(recentlyViewedProducts));

    if(recentlyViewedProducts.length > 1){
      $('.recently_viewed_product .grid.grid--uniform').empty();
      $('.recent_heading').show();
      $('.popular_heading').hide();
    }
    // Fetch product details and render them
    recentlyViewedProducts.forEach(function(productId) {
      fetch(`/products/${productId}.js`)
        .then(response => response.json())
        .then(product => {
          if (product.handle === product_handle) {
            return; // Skip this product
          }
          var product_url = `${location.origin}/products/${product.handle}?view=recently_view_product` 
          // console.log("Call recently view product_url == ", product_url);
          $.ajax({
            url: product_url,
            type: "GET",
            success: function (data) {
              $(data).appendTo(".recently_viewed_product .grid.grid--uniform");
            },
            error: function (error) {
              // Log an error message if the AJAX request fails
              console.error("Error fetching product information:", error);
            },
          });
        })
        .catch(error => console.error('Error fetching product data:', error));
    });
  }
});

// gift card page js start
$(document).ready( function () {
  $('<div id = "newElement" class="qty_cart_btn"></div>').insertBefore($('.template_custom-gift-temp .product__quantity--button'));
  // $("body").append('<div id = "newElement" class="qty_cart_btn"></div>');
   $('.template_custom-gift-temp .product__quantity--button').appendTo('.qty_cart_btn');
  $('.template_custom-gift-temp .btn.add-to-cart').appendTo('.qty_cart_btn');
  $(".template_custom-gift-temp .gift-card-recipient__fields input").removeAttr("required");
  var checkbox_value = $(".template_custom-gift-temp .checkbox-control").find("input[type='checkbox']").is(':checked');
  if(checkbox_value == "true"){
    $(".template_custom-gift-temp .gift-card-recipient__fields").css('opacity', '1');
    $(".template_custom-gift-temp .gift-card-recipient__fields").css('pointer-events', 'all');
  }
});

$('.template_custom-gift-temp .checkbox-control .checkbox').click(function(){
  var checkbox_value = $(this).is(':checked');
  console.log("***********checkbox_value***************" , checkbox_value)
  if(checkbox_value){
    $(".template_custom-gift-temp .gift-card-recipient__fields").css('opacity', '1');
    $(".template_custom-gift-temp .gift-card-recipient__fields").css('pointer-events', 'all');
    $(".template_custom-gift-temp .gift-card-recipient__fields input").attr("required", "true");
    $(".template_custom-gift-temp .gift-card-recipient__fields input[type='date']").removeAttr("required");
  } else {
    $(".template_custom-gift-temp .gift-card-recipient__fields").css('opacity', '0.3');
    $(".template_custom-gift-temp .gift-card-recipient__fields").css('pointer-events', 'none');
     $(".template_custom-gift-temp .gift-card-recipient__fields input").removeAttr("required");
  }
});
$('.template_custom-gift-temp .variant-wrapper-image .variant__button-label').click(function(){
  $('.template_custom-gift-temp .input_label').removeClass('active');
  console.log("click event")
  $(this).find('.input_label').addClass('active');
});



$('.gift-slideshow-wrapper').slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  autoplay: false,
  autoplaySpeed: 1000,
});

// gift card page js end